import * as React from 'react'

export enum IconName {
  x,
  play,
  pause,
  timer,
  cards,
  person,
  downChevron,
  leftChevron,
  skip,
  prev,
  replay,
}

interface IProps {
  className?: string
  name: IconName
  color?: string
}

const Icon: React.StatelessComponent<IProps> = props => {
  const className = props.className ? 'icon' + ' ' + props.className : 'icon'
  const color = props.color ? props.color : 'currentColor'

  switch (props.name) {
    case IconName.x:
      return (
        <svg className={className} height="10" viewBox="0 0 10 10" width="10">
          <path
            d="m9.72912 8.13377-3.13596-3.13417 3.13365-3.13571c.36169-.36017.36169-.939447.0015-1.301118l-.29116-.291884c-.17109-.1755833-.40523-.27088787-.65136-.27088787h-.0015c-.24612 0-.47727.09679677-.64986.27011987l-3.13519 3.13725-3.13595-3.133408c-.35946-.360173-.938025-.3616714-1.299724-.001501l-.291907.288887c-.1755978.172583-.27165882.406697-.27165882.652052 0 .24688.09680442.47874.27014082.65206l3.137499 3.13494-3.134425 3.13571c-.3616995.36017-.3616994.93945-.001501 1.30187l.291158.29113c.172597.17559.40598.27089.652108.27089.24463 0 .47877-.09755.65136-.27012l3.13442-3.13648 3.13519 3.13283c.17785.17934.41422.27012.65136.27012.23489 0 .46976-.08929.64986-.26862l.29115-.29039c.17635-.17108.27166-.4052.27166-.6513.00152-.24611-.0953-.47874-.26864-.65206z"
            fill={color}
          />
        </svg>
      )
    case IconName.play:
      return (
        <svg className={className} height="40" viewBox="0 0 36 40" width="36">
          <path
            d="m22.6699 7.5c1.9245-3.33334 6.7357-3.33333 8.6602 0l14.7225 25.5c1.9245 3.3333-.4812 7.5-4.3302 7.5h-29.4448c-3.84904 0-6.25466-4.1667-4.33016-7.5z"
            transform="matrix(0 1 -1 0 41 -7)"
            fill={color}
          />
        </svg>
      )
    case IconName.pause:
      return (
        <svg className={className} height="40" viewBox="0 0 38 40" width="38">
          <g>
            <rect height="40" rx="5" width="10" x="28" fill={color} />
            <rect height="40" rx="5" width="10" fill={color} />
          </g>
        </svg>
      )
    case IconName.timer:
      return (
        <svg className={className} height="26" viewBox="0 0 21 26" width="21">
          <path
            d="m11.6928 3.83359v-1.05655h1.0584l-.0011-2.77704002h-4.5003v2.77704002h1.05842v1.05655c-1.40979.16406-2.73389.6125-3.91868 1.28954l-.89023-1.36173-1.39371.94937.89343 1.36609c-2.43178 1.96546-3.9990301 4.99744-3.9990301 8.40224.0010712 5.9116 4.7115201 10.7209 10.5005001 10.7209 5.7891 0 10.4995-4.8093 10.4995-10.7198 0-5.49946-4.0783-10.03938-9.3073-10.64642zm-1.1923 19.41741c-4.73706 0-8.59047-3.9343-8.59047-8.7707 0-4.83644 3.85341-8.77071 8.59047-8.77071 4.737 0 8.5904 3.93427 8.5904 8.77071 0 4.8356-3.8534 8.7707-8.5904 8.7707z"
            fill="#9ea6a5"
          />
        </svg>
      )
    case IconName.cards:
      return (
        <svg className={className} height="24" viewBox="0 0 27 24" width="27">
          <path
            d="m22.7051.00022206-8.311.09553254c-.5764.0062034-1.1322.1799014-1.6089.4876054l-3.84308 1.06576c-.0146.00372-.02919.00869-.04257.01365l-1.31219.46525-.00122-.00125-.00729.00373-.15081.05335c-.37213.13151-.71266.33499-1.00453.59305l-1.13101.63152-.77468.44044-.01216-.01737-.12283.09429-.37945.21464c-.33443.19107-.62873.44168-.86954.73821l-1.96285 1.49877c-.00608.00372-.01094.00868-.01581.0124-.642114.52356-1.044664 1.27047-1.1358528 2.10297-.0899931.82384.1362068 1.63403.6384758 2.28533l7.969427 12.0037c.00852.0137.01946.0273.02919.041.62509.7977 1.55548 1.2009 2.48578 1.1761.6421-.0173 1.2855-.2394 1.8254-.6774l2.2085-1.6613 2.4943-.4801 1.2733-.2432-.0061.1017 4.0255.1142c.0158-.0013.0316-.0013.0474-.0013 1.6686-.0446 3.0076-1.6277 2.9893-3.3324l-.1824-14.63641c-.0195-1.72952-1.4168-3.2009406-3.1121-3.18251883zm-15.85855 4.25447794c.08513-.15881.19215-.30149.31619-.42555l.93035-.51984.46457-.16501c-.24566.57196-.32105 1.21215-.20675 1.83497l2.43589 14.31753-4.05692-13.51841c-.00243-.00744-.00486-.01489-.0073-.02233-.16904-.4938-.12404-1.04093.12405-1.50125zm4.50585-.98512.1581 12.78152-1.92268-11.29635c-.00122-.00372-.00122-.0062-.00243-.00992-.09365-.5087.02675-1.03969.332-1.45408.27241-.37098.66891-.62406 1.11641-.70969l.4001-.07692c-.0559.24814-.0839.50371-.0815.76552zm-5.97377 1.5608c-.04499.44663.00365.90197.14959 1.33497l4.07282 13.57305-5.67213-11.92176c-.00486-.01116-.01094-.02109-.01702-.03226-.25417-.46524-.29917-1.01983-.12405-1.52357.05716-.16377.13621-.31762.23472-.45658l1.04467-.79775zm-3.72133 5.16762c-.30282-.38711-.44025-.86973-.38673-1.36105.05351-.48884.28944-.9268.664-1.23572l.49496-.37717c.02067.47519.14593.94542.37456 1.36972l5.58806 11.74672-6.70574-10.1018-.02918-.04092zm23.0786 7.6774c.0109 1.0062-.782 1.8462-1.7671 1.8722l-8.3402.0968c-1.0021.0112-1.8254-.8114-1.8363-1.8325l-.18-14.55827c-.0049-.40944.1204-.799.3587-1.12655.0317-.04467.0657-.08561.0973-.12283.3381-.38835.8027-.61043 1.311-.62406l8.339-.09553c1.0021-.01117 1.8254.81018 1.8363 1.83249z"
            fill="#9ea6a5"
          />
        </svg>
      )
    case IconName.person:
      return (
        <svg className={className} height="14" viewBox="0 0 13 14" width="13">
          <path
            clipRule="evenodd"
            d="m8.91833 3.15527c0 1.49649-1.05981 2.75504-2.46972 3.07605 2.85083.34693 5.05139 2.76343 5.05139 5.67478 0 .3293-.2693.5939-.5964.5939h-10.307164c-.352173 0-.596436-.2728-.596436-.5939 0-2.91059 2.18481-5.32736 5.0343-5.67469-1.40979-.32073-2.47034-1.57882-2.47034-3.07614 0-1.75659 1.43067-3.15527 3.17725-3.15527s3.17712 1.41632 3.17712 3.15527zm-1.19262 0c0 1.08109-.89112 1.96753-1.98438 1.96753-1.09387 0-1.98425-.88708-1.98425-1.96753 0-1.08108.89111-1.96756 1.98425-1.96756 1.09388 0 1.98438.88651 1.98438 1.96756zm-1.9845 4.23859c2.30725 0 4.23193 1.71939 4.52199 3.93594h-9.04408c.29004-2.21582 2.21496-3.93594 4.52209-3.93594z"
            fill="#9EA6A5"
            fillRule="evenodd"
            transform="translate(.75 .75)"
          />
        </svg>
      )
    case IconName.downChevron:
      return (
        <svg className={className} height="7" viewBox="0 0 12 7" width="12">
          <path
            d="m11.81.200659c-.2534-.2529483-.6649-.2535781-.9195-.001892l-4.89496 4.843223-4.88548-4.852751c-.254025-.2523185-.665546-.2523185-.919551 0-.254004.252318-.2540202.661082 0 .913381l5.344591 5.30814c.12701.12616.2934.18924.45978.18924.16574 0 .33213-.06308.45913-.18798l5.35479-5.29861c.2541-.251058.2553-.659806.0013-.912754z"
            fill="#B2B1AB"
          />
        </svg>
      )
    case IconName.leftChevron:
      return (
        <svg className={className} height="14" viewBox="0 0 8 14" width="8">
          <path
            d="m.690575 5.22263 4.720945-4.775495c.31282-.315262.74625-.4766789 1.18664-.44266794.44039.03401094.84448.25966394 1.10658.61920394.43877.632149.35818 1.493249-.1895 2.030849l-4.21055 4.2578 4.25278 4.30088c.31173.3169.47134.7547.43824 1.2006-.03363.4454-.25729.8541-.6128 1.1191-.62508.4438-1.47654.3623-2.00812-.1921l-4.684051-4.73877c-.44199-.44861-.69073903-1.05593-.69073903-1.68977 0-.63323.24874903-1.2411.69073903-1.68977z"
            fill="#294202"
          />
        </svg>
      )
    case IconName.skip:
      return (
        <svg className={className} height="9" viewBox="0 0 10 9" width="10">
          <path
            clipRule="evenodd"
            d="m10 0h-2.61426v9h2.61426zm-3.96313 4.77057-6.03687 4.06586v-8.131718z"
            fill="#afaea8"
            fillRule="evenodd"
          />
        </svg>
      )
    case IconName.prev:
      return (
        <svg className={className} height="9" viewBox="0 0 10 9" width="10">
          <g fill="#afaea8">
            <path
              d="m.00000041-.00000007h2.61433959v9.00000007h-2.61433959z"
              transform="matrix(-1 0 0 1 2.61426 0)"
            />
            <path
              d="m-.00000003 8.13172 6.03679003-4.06586-6.03679003-4.06586009z"
              transform="matrix(-1 0 0 1 10 .704712)"
            />
          </g>
        </svg>
      )
    case IconName.replay:
      return (
        <svg
          className={className}
          height="14"
          viewBox="0 0 14 14"
          width="14"
        >
          <path
            d="m6.99999 14c3.67391 0 6.74301-2.8705 6.98471-6.53459.0077-.11922-.0339-.23953-.117-.32702-.0831-.08805-.1985-.13836-.3194-.13836h-.8766c-.2286 0-.4189.17609-.4364.40413-.2084 2.71734-2.50797 4.84574-5.23531 4.84574-2.89521 0-5.25001-2.35474-5.25001-5.24991 0-2.89462 2.3548-5.24997 5.25001-5.24997 1.24523 0 2.44566.44298 3.38901 1.24359l-1.51049 1.51045c-.12469.12468-.16243.31281-.09516.47686.06727.16297.2275.27016.40414.27016h4.37501c.2417 0 .4375-.19632.4375-.4375v-4.374967c0-.177729-.1066-.336866-.2702-.4052274-.0536-.0224223-.111-.03226561-.1673-.03226561-.1138 0-.2259.04484311-.3095.12796701l-1.6259 1.625253c-.0071-.00711-.0098-.01641-.018-.02297-1.2731-1.116719-2.91046-1.73137-4.60909-1.73137-3.8598 0-7.00001 3.14074-7.00001 6.99995 0 3.85975 3.14021 6.99995 7.00001 6.99995z"
            fill="#afaea8"
          />
        </svg>
      )
  }

  console.error(`[Icon] Unknown icon requested: `, props.name)
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon.tsx